function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsLove = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 347.12 307.75",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.28,13.18C212.41,16,197.12,25,186.91,35.57a18.5,18.5,0,0,1-26.71,0C150,25,134.69,16,111.83,13.18c-2.92-.35-5.83-.57-8.75-.63C15.19,11-66.31,144.51,153,286.62c1.4.91,4.95,3.05,8.72,5.31a23.09,23.09,0,0,0,23.74,0c4.06-2.44,8-4.8,9.51-5.81C420.49,139.48,326.09,2.15,235.28,13.18Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "25.06999969482422px"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsLove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_Love.bd036ac2.svg";
export { ForwardRef as ReactComponent };